// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import { defaultPenerimaDariItem } from "./defaultPenerima";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const InsertPenerimaanBarangPageV1 = ({}) => {
  const params = useParams();
  const navigate = useNavigate();
  const param = useLocation();

  let initialState = {
    Tanggal: new Date(),
    BisnisUnitID: params.id,
    PurchaseOrderID: params.transid,
    NamaPenerima: "",
    LokasiGudang: "",
    Keterangan: "",
  };

  let initialStateModal = {
    SDTDate: new Date(),
    BarangID: "",
    Qty: 0,
    QtySudahDiterima: 0,
    QtyBelumDiterima: 0,
    QtyMasuk: 0,
    KeteranganDetail: "",
  };

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
  ];

  const { values, customHandler, multiFieldHandler, changeHandler, errors, touched } = useForm(
    initialState,
    validations
  );

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/GoodsAcceptance", formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/GoodsAcceptance", formData)
  );

  const detailPO = useMutation(() =>
    fetchGet(
      `Procurement/PurchaseOrder/warehouse/${params.transid}?bisnisUnitID=${params.id}`
    )
  );

  // ModalOpener dipanggil saat klik baris — delegate ke ModalEdit agar tidak duplikat item
  const ModalOpener = (rowDetail) => {
    const idx = detail.findIndex(
      (d) => d.PurchaseOrderListID === rowDetail.PurchaseOrderListID
    );
    if (idx !== -1) {
      ModalEdit(rowDetail, idx);
    }
  };

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail({
      ...detail,
      QtyMasuk: detail.QtyMasuk || 0,
      // Hitung ulang QtyBelumDiterima berdasarkan QtyMasuk yang sudah diisi
      QtyBelumDiterima: (detail.Qty || 0) - (detail.QtySudahDiterima || 0) - (detail.QtyMasuk || 0)
    });
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
    toast.success("Data berhasil dihapus");
  };

  useEffect(() => {
    barang.mutate();

    console.log("DEBUG Frontend - Params:", {
      transid: params.transid,
      id: params.id,
    });

    detailPO.mutate();
  }, []);

  useEffect(() => {
    if (values.PurchaseOrderID !== "" && detailPO.data) {
      console.log("DEBUG Frontend - Data received:", detailPO.data.data);
      // Tambah field QtyMasuk untuk setiap item dan hitung QtyBelumDiterima
      const dataWithQtyMasuk = detailPO.data.data.map(item => ({
        ...item,
        QtyMasuk: item.QtyMasuk || 0,
        // Hitung QtyBelumDiterima = Qty PO - Qty Sudah Diterima - Qty Masuk (yang akan diterima)
        QtyBelumDiterima: (item.Qty || 0) - (item.QtySudahDiterima || 0) - (item.QtyMasuk || 0)
      }));
      setDetail(dataWithQtyMasuk);

      // Otomatis isi Nama Penerima & Lokasi Gudang menurut jenis barang (hanya bila masih kosong).
      const def = defaultPenerimaDariItem(detailPO.data.data);
      if (def) {
        multiFieldHandler({
          NamaPenerima: values.NamaPenerima || def.NamaPenerima,
          LokasiGudang: values.LokasiGudang || def.LokasiGudang,
        });
      }
    }
  }, [detailPO.data]);

  useEffect(() => {
    if (mutationUpdate.isSuccess) {
      navigate("/gudang/transaction/penerimaan-barang/" + values["BisnisUnitID"]);
    }
  }, [mutationUpdate.isSuccess]);

  useEffect(() => {
    if (mutationAdd.isSuccess) {
      navigate("/gudang/transaction/penerimaan-barang/" + values["BisnisUnitID"]);
    }
  }, [mutationAdd.isSuccess]);

  const header = [
    { name: "Nama Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Spec", key: "Spec", modifiers: "Text" },
    { name: "Satuan", key: "BarangID", modifiers: "BarangSatuan" },
    { name: "Stok Saat Ini", key: "SaldoAkhir", modifiers: "number" },
    { name: "Jumlah Pesanan (PO)", key: "Qty", modifiers: "number" },
    { 
        name: "Jumlah sudah di Terima", 
        key: "QtySudahDiterima",
        modifiers: "number" 
    },
    { 
        name: "Jumlah belum di Terima", 
        key: "QtyBelumDiterima",
        modifiers: "number" 
    },
    { name: "Jumlah di Terima", key: "QtyMasuk", modifiers: "number" },
    { name: "Keterangan", key: "KeteranganDetail", modifiers: "Text" },
    { name: "Aksi", key: "EditDelete", modifiers: "Edit" },
  ];

  const modalHandler = (value, names) => {
    let newValues = { ...modalDetail };
    
    if (names === "QtyMasuk") {
      const qtyMasuk = parseFloat(value) || 0;
      const qtyPO = parseFloat(newValues.Qty) || 0;
      const qtySudahDiterima = parseFloat(newValues.QtySudahDiterima) || 0;
      
      // Hitung QtyBelumDiterima yang baru
      const qtyBelumDiterimaBaru = qtyPO - qtySudahDiterima - qtyMasuk;
      
      if (qtyBelumDiterimaBaru < 0) {
        toast.error(`Qty Terima tidak boleh lebih dari ${qtyPO - qtySudahDiterima}`);
        return;
      }
      
      newValues = {
        ...newValues,
        QtyMasuk: qtyMasuk,
        QtyBelumDiterima: qtyBelumDiterimaBaru
      };
    } else {
      newValues[names] = value;
    }
    
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const { name, value } = event.target;
    let newValues = { ...modalDetail };

    if (name === "QtyMasuk") {
      // Validasi: tidak boleh nilai minus
      if (value.startsWith("-")) {
        toast.error("Qty Terima tidak boleh bernilai minus");
        return;
      }

      const qtyMasuk = parseFloat(value) || 0;
      const qtyPO = parseFloat(newValues.Qty) || 0;
      const qtySudahDiterima = parseFloat(newValues.QtySudahDiterima) || 0;

      // Hitung QtyBelumDiterima yang baru
      const qtyBelumDiterimaBaru = qtyPO - qtySudahDiterima - qtyMasuk;

      if (qtyBelumDiterimaBaru < 0) {
        toast.error(`Qty Terima tidak boleh lebih dari ${qtyPO - qtySudahDiterima}`);
        return;
      }

      newValues = {
        ...newValues,
        QtyMasuk: qtyMasuk,
        QtyBelumDiterima: qtyBelumDiterimaBaru
      };
    } else {
      newValues[name] = value;
    }

    setModalDetail(newValues);
  };

  const inputBuilder = [
    {
      type: "Barang",
      name: "BarangID",
      title: "Barang",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "Qty",
      title: "Qty PO",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "QtySudahDiterima",
      title: "Qty Sudah Diterima",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "QtyBelumDiterima",
      title: "Qty Belum Diterima",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "QtyMasuk",
      title: "Qty Terima",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: true,  // Bisa diedit
    },
  ];

  // Keterangan per barang diisi otomatis (bukan input manual):
  //   sisa PO setelah penerimaan ini = 0  -> "Barang Sudah di Terima Semua"
  //   masih ada sisa                      -> "Barang Belum diTerima <jumlah sisa>"
  const keteranganOtomatis = (item) => {
    const qtyPO = parseFloat(item.Qty) || 0;
    const sudah = parseFloat(item.QtySudahDiterima) || 0;
    const masuk = parseFloat(item.QtyMasuk) || 0;
    const sisa = Math.round((qtyPO - sudah - masuk) * 10000) / 10000;
    if (sisa <= 0) return "Barang Sudah di Terima Semua";
    return `Barang Belum diTerima ${sisa}`;
  };

  const handleModalSubmit = () => {
    // Validasi final sebelum submit
    const qtyMasuk = parseFloat(modalDetail.QtyMasuk) || 0;
    const qtyBelumDiterima = parseFloat(modalDetail.QtyBelumDiterima) || 0;
    
    if (qtyBelumDiterima < 0) {
      toast.error("Qty Terima melebihi batas yang diperbolehkan");
      return;
    }
    
    if (qtyMasuk <= 0) {
      toast.error("Qty Terima harus lebih dari 0");
      return;
    }

    if (showModalEdit) {
      let newValues = [...detail];
      newValues[modalID] = {
        ...modalDetail,
        QtyMasuk: qtyMasuk,
        QtyBelumDiterima: qtyBelumDiterima
      };
      setDetail(newValues);
      setModalDetail(initialStateModal);
      setShowModal(false);
      setShowModalEdit(false);
      toast.success("Data berhasil diubah");
    } else {
      const newValues = [...detail, {
        ...modalDetail,
        QtyMasuk: qtyMasuk,
        QtyBelumDiterima: qtyBelumDiterima
      }];
      setDetail(newValues);
      setModalDetail(initialStateModal);
      setShowModal(false);
      toast.success("Data berhasil ditambah");
    }
  };

  const Kirim = () => {
    // Cegah simpan ganda: klik kedua saat permintaan pertama masih berjalan
    // dulu melahirkan dua dokumen penerimaan identik (mis. PO1546).
    if (mutationAdd.isLoading) return;

    // Validasi sebelum kirim - HANYA barang yang sedang diterima (QtyMasuk > 0).
    // Dulu semua baris diperiksa, sehingga satu baris PO yang sudah minus (data
    // lama yang tersimpan ganda) memblokir penerimaan barang lain di PO itu.
    const melebihi = detail.filter(item => {
      const qtyMasuk = parseFloat(item.QtyMasuk) || 0;
      const sisa = (parseFloat(item.Qty) || 0) - (parseFloat(item.QtySudahDiterima) || 0);
      return qtyMasuk > 0 && qtyMasuk > sisa + 1e-9;
    });

    if (melebihi.length > 0) {
      const contoh = melebihi[0];
      const sisa = Math.max(0, (parseFloat(contoh.Qty) || 0) - (parseFloat(contoh.QtySudahDiterima) || 0));
      toast.error(
        `Qty Terima melebihi sisa PO untuk ${melebihi.length} barang (mis. ${contoh.BarangID}: diinput ${contoh.QtyMasuk}, sisa ${sisa})`
      );
      return;
    }

    const hasQtyMasuk = detail.some(item => {
      const qtyMasuk = parseFloat(item.QtyMasuk) || 0;
      return qtyMasuk > 0;
    });

    if (!hasQtyMasuk) {
      toast.error("Minimal ada satu barang dengan Qty Terima lebih dari 0");
      return;
    }

    let newValues = { ...values };
    try {
      newValues["Tanggal"] = newValues["Tanggal"].toISOString();
    } catch (err) {
      console.error("Error converting date:", err);
    }
    
    let detailUp = detail.map(item => {
      const qty = parseFloat(item["QtyMasuk"]) || 0;
      return {
        PurchaseOrderListID: String(item.PurchaseOrderListID),
        Keterangan: keteranganOtomatis(item),
        Qty: qty
      };
    }).filter(item => item.Qty > 0);

    if (detailUp.length === 0) {
      toast.error("Tidak ada data yang akan dikirim");
      return;
    }

    newValues["Status"] = "1";
    newValues["Data"] = detailUp;

    console.log("Data yang dikirim:", newValues);
    mutationAdd.mutate(newValues);
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate(
                        "/gudang/transaction/penerimaan-barang/" +
                          values["BisnisUnitID"]
                      )
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim()}
                    disabled={mutationAdd.isLoading}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </button>
                </div>

                {values["BisnisUnitID"] && (
                  <>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"text"}
                        value={values}
                        name={"PurchaseOrderID"}
                        title={"Purchase Order ID"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={true}
                      />
                    </div>

                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"dateOnly"}
                        value={values}
                        name={"Tanggal"}
                        title={"Tanggal Terima Barang"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"KaryawanPemohon"}
                        value={values}
                        name={"NamaPenerima"}
                        title={"Nama Penerima"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"LokasiGudang"}
                        value={values}
                        name={"LokasiGudang"}
                        title={"Lokasi Gudang"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                    <div className="w-1/2">
                      <HrdInputGenerator
                        type={"text"}
                        value={values}
                        name={"Keterangan"}
                        title={"Keterangan"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                  </>
                )}

                <hr />
                <DynamicTableSimple
                  data={detail.map((d) => ({
                    ...d,
                    KeteranganDetail: (parseFloat(d.QtyMasuk) || 0) > 0 ? keteranganOtomatis(d) : "",
                  }))}
                  header={header}
                  Master={false}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => setShowModal(false)}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full">
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            key={id}
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                      return null;
                    }
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color="green"
                  disabled={mutation.isLoading}
                  onClick={handleModalSubmit}
                  ripple="light"
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertPenerimaanBarangPageV1;